import Config from '@/config.js'
import BaseService from '@/data/base/service.js'
import dataName from './data-name.js'

export default class Service extends BaseService {
  constructor () {
    super(dataName)
    this.apis = Object.assign(this.apis, {
    })

    // fake data
    if (Config.useFakeData) {
      this.apis = Object.assign(this.apis, {
        getAll: () => new Promise((resolve, reject) => {
          var res = {
            data: {
              status: 'ok',
              result: []
            }
          }
          resolve(res)
        })
      })
    }
  }
}
